export default __webpack_public_path__ + "static/media/search_black_24dp.b56cb96d.svg";